import ButtonsWrapper, { ButtonsWrapperProps } from '../common/ButtonsWrapper';
import { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';

export type FooterLayoutProps = {
  className?: any;
  primaryLeftButton?: ButtonsWrapperProps;
  secondaryLeftButton?: ButtonsWrapperProps;
  children?: ReactElement;
  onePageTwoPageButtons?: boolean;
  primaryRightButton?: ButtonsWrapperProps;
  secondaryRightButton?: ButtonsWrapperProps;
};

const FooterLayout: React.FC<FooterLayoutProps> = (props) => {
  const {
    children,
    className,
    primaryLeftButton,
    primaryRightButton,
    secondaryLeftButton,
    secondaryRightButton,
  } = props;
  const classes = styles();

  return (
    <footer className={`${classes.container} ${className}`}>
      <div className={classes.leftContainer}>
        {primaryLeftButton && <ButtonsWrapper {...primaryLeftButton} />}
        {secondaryLeftButton && <ButtonsWrapper {...secondaryLeftButton} />}
      </div>
      <div className={classes.centerContainer}>{children}</div>
      <div className={classes.rightContainer}>
        {secondaryRightButton && <ButtonsWrapper {...secondaryRightButton} />}
        {primaryRightButton && <ButtonsWrapper {...primaryRightButton} />}
      </div>
    </footer>
  );
};

export default FooterLayout;

const styles = makeStyles((theme) => ({
  container: {
    bottom: '0px',
    height: theme.typography.pxToRem(theme.constants.app.footerOffset),
    padding: `0 ${theme.typography.pxToRem(theme.constants.app.paddingX)}`,
    paddingBottom: theme.typography.pxToRem(theme.constants.app.paddingY),
    position: 'absolute',
    width: '100%',
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pointerEvents: 'none',
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gridGap: theme.typography.pxToRem(38),
    '& button': {
      pointerEvents: 'auto',
    },
  },
  centerContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gridGap: '1rem',
    '& button': {
      pointerEvents: 'auto',
    },
  },
  rightContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gridGap: theme.typography.pxToRem(38),
    flex: 1,
    '& button': {
      pointerEvents: 'auto',
    },
  },
}));
